import { Injectable } from '@angular/core';

import { WallObjectDrag } from './wall-object-drag';
import { ObjectCheckerService } from '../../../../../services/object-checker.service';
import { WallCutService } from '../../../../../services/wall/wall-cut.service';
import { CollisionService } from '../../../../../services/collision/collision.service';
import { DragHandlerBase } from '../../Handler/drag-handler-base';

declare const THREE: any;

class WallEmbeddableObjectDrag extends WallObjectDrag {
  private wall: any;

  constructor(
    handler,
    private wallCutSrvc: WallCutService,
    objectCheckerSrvc: ObjectCheckerService,
    collisionSrvc: CollisionService
  ) {
    super(handler, objectCheckerSrvc, collisionSrvc);
  }

  canExecute(selected) {
    return selected.every(obj => this.objectCheckerSrvc.isWallEmbeddable(obj));
  }

  move(e, transformation) {
    this.wall = e.draggedObject.parent;
    super.move(e, transformation);
    this.wallCutSrvc.cutHoles(this.wall);
  }

  release(e) {
    super.release(e);
    this.wallCutSrvc.cutHoles(this.wall);
    this.wall = null;
  }

  getStaticObjectsFilter(objects) {
    const baseFilter = super.getStaticObjectsFilter(objects);
    return obj => baseFilter(obj) && this.objectCheckerSrvc.isWallEmbeddable(obj);
  }
}

@Injectable()
export class WallEmbeddableObjectDragFactory {
  constructor(
    private wallCutSrvc: WallCutService,
    private objectCheckerSrvc: ObjectCheckerService,
    private collisionSrvc: CollisionService
  ) {}

  create(nextHandler?: DragHandlerBase) {
    return new WallEmbeddableObjectDrag(
      nextHandler,
      this.wallCutSrvc,
      this.objectCheckerSrvc,
      this.collisionSrvc
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Behavior/WallObject/wall-embeddable-object-drag.ts